const nameOf = (appointment, type) =>
  String(type === "parent"
    ? appointment?.parentId?.fullName || ""
    : appointment?.petObjectId?.fullName || "").trim()

export const filterAndSortAppointments = (appointments, query, sortBy) => {
  const search = String(query || "").trim().toLocaleLowerCase()
  const matches = (Array.isArray(appointments) ? appointments : []).filter(item =>
    !search || [nameOf(item, "pet"), nameOf(item, "parent")]
      .some(name => name.toLocaleLowerCase().includes(search))
  )

  return [...matches].sort((left, right) => {
    if (["pet-asc", "pet-desc", "parent-asc", "parent-desc"].includes(sortBy)) {
      const [type, direction] = sortBy.split("-")
      const comparison = nameOf(left, type).localeCompare(nameOf(right, type), undefined, { sensitivity: "base" })
      return direction === "desc" ? -comparison : comparison
    }
    const leftDate = Date.parse(left?.date || left?.createdAt || "") || 0
    const rightDate = Date.parse(right?.date || right?.createdAt || "") || 0
    return sortBy === "oldest" ? leftDate - rightDate : rightDate - leftDate
  })
}
